import { InvoiceInput, InvoiceResponse, RunSaveInvoiceInput } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { RunSaveInvoiceDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

type RunSaveInvoiceGraphApiResponse = GraphApiResponse<typeof RunSaveInvoiceDocument>;

const title = 'Save Invoice';

const runSaveInvoiceResponseSelector = (res: RunSaveInvoiceGraphApiResponse): InvoiceResponse =>
  !res.errors ? (res?.runSaveInvoice?.output as InvoiceResponse) : undefined;

const [runRunSaveInvoice] = graphApi(RunSaveInvoiceDocument, {});

export const runSaveInvoice = async (invoice: InvoiceInput): Promise<InvoiceResponse> => {
  const input: RunSaveInvoiceInput = { input: invoice };
  const res = await runRunSaveInvoice({ input });

  const selected = runSaveInvoiceResponseSelector(res);
  return selected;
};

export const useRunSaveInvoice = createGraphApiHook(runSaveInvoice);

export default runSaveInvoice;
